<template>
    <div class="fhv-centent">
            <h4 class="title-topic">IPv6 Configuration</h4>
            <el-form 
            :model="lanIPv6Form"  
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            v-loading="loading"
            :rules="formCheck" 
            ref="lanIPv6Form"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
                <el-form-item label="Managed Flag :">
                    <el-switch v-model="lanIPv6Form.managedFlag"></el-switch>
                </el-form-item>
                <el-form-item label="Other Config Flag :">
                    <el-switch v-model="lanIPv6Form.otherFlag"></el-switch>
                </el-form-item>
                <el-form-item label="Max RA Interval :" prop="maxRA">
                    <el-input v-model.number="lanIPv6Form.maxRA">
                        <template slot="append">Seconds</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="Min RA Interval :" prop="minRA">
                    <el-input v-model.number="lanIPv6Form.minRA">
                        <template slot="append">Seconds</template>
                    </el-input>
                </el-form-item>
                
                
                <el-form-item label="Enable DHCP6S :">
                    <el-switch v-model="lanIPv6Form.dhcpEnable"></el-switch>
                </el-form-item>
                <div v-if="lanIPv6Form.dhcpEnable" key="DHCP6S">
                    <el-form-item label="Start IPv6 Address :" prop="dhcpStart">
                        <el-input v-model="lanIPv6Form.dhcpStart"></el-input>
                    </el-form-item>
                    <el-form-item label="End IPv6 Address :" prop="dhcpEnd">
                        <el-input v-model="lanIPv6Form.dhcpEnd"></el-input>
                    </el-form-item>
                </div>
                <el-form-item label="" >
                    <el-radio-group v-model="lanIPv6Form.mode">
                        <el-radio label="0" >IPv6 LAN Automatically</el-radio>
                        <el-radio label="1" >IPv6 LAN Manually</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="areaCode != 'AIS' && lanIPv6Form.mode === '1'" key="Manually">
                    <el-form-item label="IPv6/Prefix :" prop="ipAddr">
                        <el-input v-model="lanIPv6Form.ipAddr"></el-input>
                    </el-form-item>
                    <el-form-item label="DNS Server :" prop="dns1">
                        <el-input v-model="lanIPv6Form.dns1"></el-input>
                    </el-form-item>
                    <el-form-item label="Prefix Set :" prop="prefix">
                        <el-input v-model="lanIPv6Form.prefix"></el-input>
                    </el-form-item>
                </div>
                <div v-if="areaCode == 'AIS'">
                    <div v-if="lanIPv6Form.mode === '1'" key="Manually">
                        <el-form-item label="IPv6/Prefix :" prop="ipAddr">
                            <el-input v-model="lanIPv6Form.ipAddr"></el-input>
                        </el-form-item>
                        <el-form-item label="Prefix Set :" prop="prefix">
                            <el-input v-model="lanIPv6Form.prefix"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="DNS Mode :" >
                        <el-radio-group v-model="lanIPv6Form.dns_mode">
                            <el-radio label="0" >Relay</el-radio>
                            <el-radio label="1" >Proxy</el-radio>
                            <el-radio label="2" >Static</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div v-if="lanIPv6Form.dns_mode === '2'" key="Static">
                        <el-form-item label="DNS Server1 :" prop="dns1">
                            <el-input v-model="lanIPv6Form.dns1"></el-input>
                        </el-form-item>
                        <el-form-item label="DNS Server2 :" prop="dns2">
                            <el-input v-model="lanIPv6Form.dns2"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item label="DHCPv6 Disable:" >
                    <el-checkbox-group v-model="DHCPv6Disable">
                        <el-checkbox 
                        v-for="itme in portList.lan"
                        :key="itme.name"
                        :label="itme.portIndex" :disabled = '!itme.enable' >{{itme.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item >
                    <el-checkbox-group v-model="DHCPv6Disable">
                        <el-checkbox 
                        v-for="itme in portList.wlan1"
                        :key="itme.name"
                        :label="itme.portIndex" :disabled = '!itme.enable' >{{itme.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                    <el-checkbox-group v-model="DHCPv6Disable">
                        <el-checkbox 
                        v-for="itme in portList.wlan0"
                        :key="itme.name"
                        :label="itme.portIndex" :disabled = '!itme.enable' >{{itme.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="RA Disable:" >
                    <el-checkbox-group v-model="RADisable">
                        <el-checkbox 
                        v-for="itme in portList.lan"
                        :key="itme.name"
                        :label="itme.portIndex" :disabled = '!itme.enable' >{{itme.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item >
                    <el-checkbox-group v-model="RADisable">
                        <el-checkbox 
                        v-for="itme in portList.wlan1"
                        :key="itme.name"
                        :label="itme.portIndex" :disabled = '!itme.enable' >{{itme.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                    <el-checkbox-group v-model="RADisable">
                        <el-checkbox 
                        v-for="itme in portList.wlan0"
                        :key="itme.name"
                        :label="itme.portIndex" :disabled = '!itme.enable' >{{itme.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="apply">Apply</el-button>
                    <el-button type="primary" @click="refresh">Refresh</el-button>
                </el-form-item>
            </el-form>
        </div>
</template>

<script>
import ipv6AddrFormat from '../../util/ipv6AddrFormat'
import ipv6Validator from '../../util/ipv6Validator.js'
import devConfig from '@/devConfig'


function checkEndDhcpv6(start,end){
    // 相等直接返回
    if(start === end) return true

    let v1 = start ,v2 = end 
    if(start.indexOf('::') == -1 && start.split(':').length === 4)
    {
        v1 = '::' + start
    }
    v1 = ipv6AddrFormat.normalize(v1)
    

    if(end.indexOf('::') == -1 && end.split(':').length === 4)
    {
        v2 = '::' + end
    }
    v2 = ipv6AddrFormat.normalize(v2)
    
    v1 = v1.split(':')
    v2 = v2.split(':')

    for (let index = 0; index < v1.length; index++) {
        let s = parseInt(`0x${v1[index]}`)
        let e = parseInt(`0x${v2[index]}`)
        if(e > s)
        {
            return true
        }
        
    }
    return false
}

    export default {
        data() {
            return {
                areaCode: 'AIS',
                srcData: {
                    ipAddr: '',
                    prefix: '',
                    dns1: '',
                    dns2: '',
                },
                portList:{
                    lan:[
                        {enable: true, portIndex: 0, name: "LAN1"},
                        {enable: true, portIndex: 1, name: "LAN2"},
                        {enable: true, portIndex: 2, name: "LAN3"},
                        {enable: true, portIndex: 3, name: "LAN4"}
                    ],
                    wlan1:[
                        {enable: true, portIndex: 10, name: "SSID1"},
                        {enable: false, portIndex: 12, name: "SSID2"},
                        {enable: false, portIndex: 13, name: "SSID3"},
                        {enable: false, portIndex: 14, name: "SSID4"}
                    ],
                    wlan0:[
                        {enable: true, portIndex: 4, name: "SSID5"},
                        {enable: false, portIndex: 6, name: "SSID6"},
                        {enable: false, portIndex: 7, name: "SSID7"},
                        {enable: false, portIndex: 8, name: "SSID8"}
                    ]
                },
                protIndex:0,
                DHCPv6Disable:[],
                RADisable:[],
                loading: false,
                lanIPv6Form:{
                    ipAddr:'fe80::10/64',
                    managedFlag:false,
                    otherFlag:true,
                    maxRA:10,
                    minRA:5,
                    mode:'0',
                    dns_mode: 0,
                    dns1:'fe80::20',
                    dns2:'fe80::20',
                    prefix:'2001:db8:3c4d:15::/64',
                    dhcpEnable:true,
                    dhcpStart:'2008::1',
                    dhcpEnd:'2008::100'
                },
                formCheck:{
                    ipAddr:[
                        { required: true, message: 'IPv6 Address cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                let ipv6Addr = value.split('/')
                                if(ipv6Addr.length === 1 || !validator.isIP(ipv6Addr[0],6))
                                    callback(new Error('IPv6 Address error! e.g. fe80::26ca/64'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    maxRA:[
                        { required: true, message: 'Max RA Interval cannot be empty.', trigger: 'blur' },
                        { type: 'number',min: 4, max: 1800, message: 'Max RA Interval range is [4-1800]Seconds.', trigger: 'blur' }
                    ],
                    minRA:[
                        { required: true, message: 'Min RA Interval cannot be empty.', trigger: 'blur' },
                        { type: 'number',min: 3, max: 1350, message: 'Min RA Interval range is [3-1350]Seconds.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(value > this.lanIPv6Form.maxRA*0.75)
                                    callback(new Error('Min RA Interval cannot be greater than 75% of Max RA Interval'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    dns1:[
                        { required: true, message: 'IPv6 dns cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(!validator.isIP(value,6))
                                    callback(new Error('IPv6 dns Address error! e.g. fe88::1'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    dns2:[
                        {
                            validator:(rule, value, callback) => {
                                if (!validator.isEmpty(value)) {
                                    if(!validator.isIP(value,6))
                                        callback(new Error('IPv6 dns Address error! e.g. fe88::1'));
                                    else if(value == this.lanIPv6Form.dns1)
                                        callback(new Error('IPv6 dns1 address and dns2 address cannot be the same!'));
                                    else
                                        callback()
                                }else {
                                    callback()
                                }
                            },
                            trigger: 'blur'
                        }
                    ],
                    prefix:[
                        { required: true, message: 'Prefix cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                let ipv6Addr = value.split('/')
                                let len  = parseInt(ipv6Addr[1])
                                if(ipv6Addr.length === 1 || !ipv6Validator(ipv6Addr[0],6,2))
                                    callback(new Error('Error! e.g. must 64-bit. e.g. 2001::/64 or 2001:1:1:1/64'));
                                else if(len != 64)
                                    callback(new Error('Error! Prefix length must is 64 e.g. 2001::/64 or 2001:1:1:1/64'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    dhcpStart:[
                        { required: true, message: 'Start IPv6 DHCP Address cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(!ipv6Validator(value,6,1))
                                    callback(new Error('Error! must 64-bit. e.g. ::1000 or 2005:1:1:1000'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ],
                    dhcpEnd:[
                        { required: true, message: 'End IPv6 DHCP Address cannot be empty.', trigger: 'blur' },
                        {
                            validator:(rule, value, callback) => {
                                if(!ipv6Validator(value,6,1))
                                    callback(new Error('Error! must 64-bit. e.g. ::2000 or 2005:1:1:2000'));
                                else if(!checkEndDhcpv6(this.lanIPv6Form.dhcpStart,value))
                                    callback(new Error('End  Address must be greater than Start Address'));
                                else
                                    callback()
                            },
                            trigger: 'blur'
                        }
                    ]
                }
            }
        },
        created(){
            devConfig.init(this, () => {
                this.areaCode = devConfig.getData().area
            })
            this.getData()
        },
        methods: {
            getData(){
                this.loading = true
                axios
                .post("/boafrm/fhLanIPv6",{CmdType:"GET_LAN_IPV6"})
                .then((response)=>{
                    this.loading = false
                    if(response.data.ret === 0)
                    {
                        this.lanIPv6Form = response.data.lanIPv6
                        this.lanIPv6Form.ipAddr = ipv6AddrFormat.abbreviate(this.lanIPv6Form.ipAddr.split('/')[0])
                                                  + '/' + this.lanIPv6Form.ipAddr.split('/')[1]
                        let prefix = ipv6AddrFormat.abbreviate(this.lanIPv6Form.prefix.split('/')[0])
                        if(prefix.split(':').length === 6 
                        && prefix.substr(prefix.length - 2, 2) === '::')
                            prefix = prefix.replace('::','')
                            
                        this.lanIPv6Form.prefix = prefix
                                                  + '/' + this.lanIPv6Form.prefix.split('/')[1]

                        this.lanIPv6Form.dhcpStart = ipv6AddrFormat.abbreviate(this.lanIPv6Form.dhcpStart)

                        if(this.lanIPv6Form.dhcpStart.split(':').length === 6 
                        && this.lanIPv6Form.dhcpStart.substr(0, 2) === '::')
                            this.lanIPv6Form.dhcpStart = this.lanIPv6Form.dhcpStart.replace('::','')

                        this.lanIPv6Form.dhcpEnd = ipv6AddrFormat.abbreviate(this.lanIPv6Form.dhcpEnd)

                        if(this.lanIPv6Form.dhcpEnd.split(':').length === 6
                        && this.lanIPv6Form.dhcpEnd.substr(0, 2) === '::')
                            this.lanIPv6Form.dhcpEnd = this.lanIPv6Form.dhcpEnd.replace('::','')
                        
                        this.DHCPv6Disable = []
                        response.data.lanIPv6.DHCPv6Disable.forEach((element,index) => {
                            if(element === 1) this.DHCPv6Disable.push(index)
                        })
                        this.RADisable = []
                        response.data.lanIPv6.RADisable.forEach((element,index) => {
                            if(element === 1) this.RADisable.push(index)
                        })

                        this.portList = response.data.lanIPv6.wlanAndLanIfanme

                        this.srcData.ipAddr = response.data.lanIPv6.ipAddr
                        this.srcData.prefix = response.data.lanIPv6.prefix
                        this.srcData.dns1 = response.data.lanIPv6.dns1
                        this.srcData.dns2 = response.data.lanIPv6.dns2
                    }
                    else
                        this.$message.error('GET data failed!')
                })
                .catch((error) => {
                    this.loading = false
                    this.$message.error('GET data failed! Network connection error!')
                })
                
            },
            setData(){
                let postData = JSON.parse( JSON.stringify( this.lanIPv6Form ) )
                postData.CmdType = 'SET_LAN_IPV6'

                if (postData.mode != 1) {
                    postData.ipAddr = ipv6AddrFormat.normalize(this.srcData.ipAddr.split('/')[0])
                    postData.ipv6AddrPrefixLen = this.srcData.ipAddr.split('/')[1]
                    postData.prefix = ipv6AddrFormat.normalize(this.srcData.prefix.split('/')[0])
                    postData.prefixLen = this.srcData.prefix.split('/')[1]
                    if (this.areaCode != "AIS") {
                        postData.dns1 = this.srcData.dns1
                    }
                }else {
                    postData.ipAddr = ipv6AddrFormat.normalize(this.lanIPv6Form.ipAddr.split('/')[0])
                    postData.ipv6AddrPrefixLen = this.lanIPv6Form.ipAddr.split('/')[1]
                    let prefix = this.lanIPv6Form.prefix.split('/')[0]
                    if(prefix.indexOf('::') == -1 && prefix.split(':').length === 4)
                    {
                        prefix = prefix + '::'
                    }
                    postData.prefix = ipv6AddrFormat.normalize(prefix)
                    postData.prefixLen = this.lanIPv6Form.prefix.split('/')[1]
                }
                
                if(this.lanIPv6Form.dhcpStart.indexOf('::') == -1 && this.lanIPv6Form.dhcpStart.split(':').length === 4)
                {
                    postData.dhcpStart = '::' + this.lanIPv6Form.dhcpStart
                }
                postData.dhcpStart = ipv6AddrFormat.normalize(postData.dhcpStart)
                if(this.lanIPv6Form.dhcpEnd.indexOf('::') == -1 && this.lanIPv6Form.dhcpEnd.split(':').length === 4 )
                {
                    postData.dhcpEnd = '::' + this.lanIPv6Form.dhcpEnd
                }
                postData.dhcpEnd = ipv6AddrFormat.normalize(postData.dhcpEnd)

                if (postData.dns_mode != 2 && this.areaCode == "AIS") {
                    postData.dns1 = this.srcData.dns1
                    postData.dns2 = this.srcData.dns2
                }
                
                
                postData.DHCPv6Disable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

                this.DHCPv6Disable.forEach(element => {
                    postData.DHCPv6Disable[element] = 1
                })

                postData.RADisable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

                this.RADisable.forEach(element => {
                    postData.RADisable[element] = 1
                })

                this.loading = true
                axios
                .post("/boafrm/fhLanIPv6",postData)
                .then((response)=>{
                    this.loading = false
                    if(response.data.ret === 0)
                        this.$message.success("Configuration is successful!")
                    else
                        this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                })
                .catch((error) => {
                    this.loading = false
                    this.$message.error('SET data failed! Network connection error!')
                })
                
            },
            apply() {
                this.$refs['lanIPv6Form'].validate((valid) => {
                    if (valid) {
                        this.setData()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
            refresh() {
                 this.getData()
            }
        },
    }
</script>

<style scoped>

</style>